var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeryPositiveMod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_66265)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8561 10.2015C25.0277 14.0324 18.6624 15.9889 12.2245 16.024C5.70213 16.0592 -0.916898 14.1379 0.109775 10.2015C3.55215 -3.03679 19.5683 -3.77485 23.8561 10.2015Z",
    fill: "url(#paint0_radial_43_66265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81377 9.50038C7.81377 10.6834 6.82788 11.6531 5.61294 11.6531C4.398 11.6531 3.41211 10.6931 3.41211 9.50038C3.41211 8.31735 4.398 7.34766 5.61294 7.34766C6.82788 7.34766 7.81377 8.30766 7.81377 9.50038Z",
    fill: "url(#paint1_radial_43_66265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9632 9.69374C19.9632 10.8768 18.9773 11.8465 17.7624 11.8465C16.5474 11.8465 15.5615 10.8865 15.5615 9.69374C15.5615 8.51071 16.5474 7.54102 17.7624 7.54102C18.9773 7.54102 19.9632 8.50102 19.9632 9.69374Z",
    fill: "url(#paint2_radial_43_66265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2334 9.30859C9.1612 11.9947 14.3595 12.2177 17.138 9.30859",
    stroke: "#F96ABA",
    strokeWidth: 0.995867,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2334 8.97852C9.1612 11.6646 14.3595 11.8876 17.138 8.97852",
    stroke: "#14110E",
    strokeWidth: 0.995867,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0557 5.42795C14.0714 4.71037 15.6947 4.85582 16.4316 5.86431",
    stroke: "#F96ABA",
    strokeWidth: 0.995867,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3173 5.42795C9.30157 4.71037 7.67834 4.85582 6.94141 5.86431",
    stroke: "#F96ABA",
    strokeWidth: 0.995867,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1553 5.23654C14.171 4.51896 15.7943 4.66442 16.5312 5.6729",
    stroke: "#14110E",
    strokeWidth: 0.995867,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4169 5.23654C9.40118 4.51896 7.77794 4.66442 7.04102 5.6729",
    stroke: "#14110E",
    strokeWidth: 0.995867,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_43_66265",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0002 8.00932) rotate(90) scale(8.01518 11.9963)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.546885,
    stopColor: "#F78BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E62490"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_43_66265",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.61468 9.4958) scale(2.20062 2.15054)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F96ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#F96ABA",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#F96ABA",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#F96ABA",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#F96ABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_43_66265",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7641 9.68916) scale(2.20062 2.15054)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F96ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#F96ABA",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#F96ABA",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#F96ABA",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#F96ABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_66265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryPositiveMod);
export default __webpack_public_path__ + "static/media/Very-Positive-mod.b686a20806d3443b7417b1c36910abb5.svg";
export { ForwardRef as ReactComponent };